import React, { useState } from "react";
import { CloudArrowDown, Spinner, CheckCircle } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { toast } from "sonner";

/**
 * Banner mostrato in PropertyDetail · Foto tab quando l'immobile ha
 * `remote_photo_urls` non vuoto (foto importate da XML gestionale, non
 * ancora scaricate nello storage Pronto).
 *
 * Click → POST /api/properties/{pid}/photos/fetch-remote → scarica e
 * sposta nello storage. Idempotente: la seconda chiamata non duplica.
 */
export default function RemotePhotosBanner({ pid, urls, onDone }) {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const count = urls?.length || 0;

  if (count === 0 || done) return null;

  const fetchNow = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/properties/${pid}/photos/fetch-remote`);
      const got = data.downloaded || 0;
      const skip = data.skipped || 0;
      if (got > 0) {
        toast.success(`Scaricate ${got} foto dal tuo gestionale${skip > 0 ? ` · ${skip} non leggibili` : ""}`);
        setDone(true);
        if (onDone) onDone();
      } else {
        toast.warning("Nessuna foto scaricabile (link rotti o file non immagine)");
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore durante il download");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="mt-6 mb-2 px-4 py-3 bg-[#F1F4ED] border border-[#A8B89A] rounded-sm flex items-center gap-3 flex-wrap"
      data-testid="remote-photos-banner"
    >
      <CloudArrowDown size={18} weight="duotone" className="text-[#5C6A4F] shrink-0" />
      <div className="flex-1 min-w-0 text-sm">
        <span className="text-[#1C1C1A]">
          <strong className="text-[#5C6A4F]">{count}</strong> {count === 1 ? "foto" : "foto"} importate dal tuo gestionale da scaricare
        </span>
        <span className="block text-[11px] text-[#6B6A65] mt-0.5">
          Le sposto nello storage Pronto così puoi migliorarle, usarle nella PDF stampabile, esportarle sui portali
        </span>
      </div>
      <button
        onClick={fetchNow}
        disabled={loading}
        className="bg-[#1C1C1A] text-white hover:bg-[#000] disabled:opacity-50 disabled:cursor-not-allowed text-[12.5px] font-semibold px-4 py-2 rounded-full inline-flex items-center gap-1.5 shrink-0 transition-colors"
        data-testid="remote-photos-fetch"
      >
        {loading ? (
          <>
            <Spinner size={13} className="animate-spin" />
            Scarico…
          </>
        ) : (
          <>
            <CloudArrowDown size={13} weight="bold" />
            Scarica le {count} foto
          </>
        )}
      </button>
    </div>
  );
}
